import type { MyWorkSiteDto } from '@app/contracts';
import { Building2 } from 'lucide-react';

interface Props {
  sites: MyWorkSiteDto[];
  selectedSiteId: string | null;
  onChange: (siteId: string) => void;
}

export function SiteSwitcher({ sites, selectedSiteId, onChange }: Props) {
  if (sites.length === 0) return null;

  return (
    <div className="flex flex-col gap-1.5 px-4 py-3">
      <label
        htmlFor="site-switcher"
        className="text-[0.7rem] font-semibold uppercase tracking-wider text-slate-500"
      >
        Site actif
      </label>
      <div className="relative">
        <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-slate-400">
          <Building2 className="h-4 w-4" />
        </div>
        <select
          id="site-switcher"
          className="w-full appearance-none rounded-xl border border-slate-200 bg-slate-50 py-2 pl-9 pr-8 text-sm font-medium text-slate-700 outline-none transition-colors hover:bg-slate-100 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/20"
          value={selectedSiteId ?? ''}
          onChange={(e) => onChange(e.target.value)}
        >
          {sites.map((s) => (
            <option key={s.siteId} value={s.siteId}>
              {s.siteName}
              {s.isPreferred ? '  ★' : ''}
            </option>
          ))}
        </select>
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3 text-slate-400">
          <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <title>Ouvrir le sélecteur</title>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </div>
    </div>
  );
}
